import React, { useState, useEffect } from "react";
import "./GallerySection.css";

// ================= IMAGE IMPORTS =================
import Img1 from "../Image/ServiceList/DeepCleaning.png";
import Img2 from "../Image/ServiceList/personcleaan.png";
import Img3 from "../Image/ServiceList/frontofficeee.png";
import Img4 from "../Image/ServiceList/EngineeringAI.png";
import Img5 from "../Image/ServiceList/FaçadeExternal.png";
import Img6 from "../Image/ServiceList/GuestHouseee.png";
import Img7 from "../Image/ServiceList/HelpdeskAI.png";
import Img8 from "../Image/ServiceList/pantryAI.png";
import Img9 from "../Image/ServiceList/House&StaffAI.png";
import Img10 from "../Image/ServiceList/industryoffice.png";
import Img11 from "../Image/ServiceList/pestmen.png";
import Img12 from "../Image/ServiceList/industree.png";
import Img13 from "../Image/ServiceList/pantryfood.png";
import Img14 from "../Image/ServiceList/pestcontroll.png";
import Img15 from "../Image/ServiceList/staffhouse.png";
import Img16 from "../Image/ServiceList/hotelroom.png";
import Img17 from "../Image/ServiceList/DeepCleaninggAI.png";
import Img18 from "../Image/ServiceList/Hellp.png";
import Img19 from "../Image/ServiceList/helpmore.png";
import Img20 from "../Image/ServiceList/eventcleaningg.png";
import Img21 from "../Image/ServiceList/EventCleanning.png";
import Img22 from "../Image/ServiceList/Densatwork.png";
import Img23 from "../Image/ServiceList/houseservices.png";
import Img24 from "../Image/ServiceList/Densatlogoo.png";
import Img25 from "../Image/ServiceList/Densatperson.png";
import Img26 from "../Image/ServiceList/Densatperson2.png";
import Img27 from "../Image/ServiceList/densatperson3.png";
import Img28 from "../Image/ServiceList/houseeee.png";
import Img31 from "../Image/ServiceList/DensatIndia.png";
import Img32 from "../Image/ServiceList/Densatperson5.png";
import Img33 from "../Image/ServiceList/Densatperson4.png";
import Img34 from "../Image/ServiceList/personcup.png";
import Img35 from "../Image/ServiceList/twoperson.png";
import Img36 from "../Image/ServiceList/personplate.png";

import gal1 from "../Image/ServiceList/gal1.webp";
import gal2 from "../Image/ServiceList/gal2.webp";
import gal3 from "../Image/ServiceList/gal3.webp";
import gal4 from "../Image/ServiceList/gal4.webp";
import gal5 from "../Image/ServiceList/gal5.webp";
import gal6 from "../Image/ServiceList/gal6.webp";
import ga17 from "../Image/GalleryHome/Gallery1.mp4";
import gal8 from "../Image/GalleryHome/Gallery2.jpeg";
import gal9 from "../Image/GalleryHome/Gallery3.jpeg";
import ga20 from "../Image/GalleryHome/Gallery4.jpeg";
import ga21 from "../Image/GalleryHome/Gallery5.jpeg";

import ga22 from "../Image/GalleryHome/Gallery6.mp4";
import ga23 from "../Image/GalleryHome/Gallery7.jpeg";


// ================= MEDIA ARRAY =================
export const media = [
  { src: Img24, type: 'image' },
  { src: Img25, type: 'image' },
  { src: Img26, type: 'image' },
  { src: Img27, type: 'image' },
  { src: Img33, type: 'image' },
  { src: gal1, type: 'image' },
  { src: gal2, type: 'image' },
  { src: gal3, type: 'image' },
  { src: gal4, type: 'image' },
  { src: gal5, type: 'image' },
  { src: gal6, type: 'image' },
  { src: gal8, type: 'image' },
  { src: gal9, type: 'image' },
  { src: ga20, type: 'image' },
  { src: ga21, type: 'image' },
  { src: ga22, type: 'video' },
  { src: ga17, type: 'video' },
  { src: ga23, type: 'image' }
];



function GallerySection() {
  const [selectedIndex, setSelectedIndex] = useState(null);

  // 🔹 Keyboard sliding support
  useEffect(() => {
    const handleKey = (e) => {
      if (selectedIndex === null) return;

      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
      if (e.key === "Escape") setSelectedIndex(null);
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [selectedIndex]);

  const nextImage = () => {
    setSelectedIndex((prev) =>
      prev === media.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setSelectedIndex((prev) =>
      prev === 0 ? media.length - 1 : prev - 1
    );
  };

  return (
    <div className="gallery-wrapper">
      <h2 className="gallery-title">Photo Gallery</h2>

      <div className="gallery-grid">
        {media.map((item, index) => (
          <div
            className="gallery-item"
            key={index}
            onClick={() => setSelectedIndex(index)}
          >
            {item.type === 'video' ? (
              <video src={item.src} alt={`Gallery-${index}`} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
              <img src={item.src} alt={`Gallery-${index}`} />
            )}
          </div>
        ))}
      </div>

      {/* LIGHTBOX WITH SLIDING */}
      {selectedIndex !== null && (
        <div className="lightbox" onClick={() => setSelectedIndex(null)}>
          <span className="close-btn">&times;</span>

          <button
            className="lightbox-nav left"
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
          >
            &#10094;
          </button>

          {media[selectedIndex].type === 'video' ? (
            <video
              src={media[selectedIndex].src}
              className="lightbox-img"
              controls
              onClick={(e) => e.stopPropagation()}
            />
          ) : (
            <img
              src={media[selectedIndex].src}
              className="lightbox-img"
              alt="Preview"
              onClick={(e) => e.stopPropagation()}
            />
          )}

          <button
            className="lightbox-nav right"
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
          >
            &#10095;
          </button>
        </div>
      )}
    </div>
  );
}

export default GallerySection;
